import React, { useEffect, useRef } from 'react'
import * as G2 from '@antv/g2'

interface MemberDataChartRow {
    date: string
    recharge_amount: number | string
    consume_amount: number | string
    member_registered: number
}

interface MemberDataChartProps {
    dataList: MemberDataChartRow[]
    scope: number
}

const formatDate = (value: string, scope: number) => {
    if (!value) return '-'
    if (scope === 1) {
        const week = Math.ceil(Number(value.substring(8, 10)) / 7)

        return `${Number(value.substring(5, 7))}月第${week}周`
    }
    if (scope === 2) return `${value.substring(2, 4)}年${Number(value.substring(5, 7))}月`

    return value
}

const MemberDataChart: React.FC<MemberDataChartProps> = props => {
    const chartsRef = useRef<G2.Chart | null>(null)

    useEffect(() => {
        if (chartsRef.current) chartsRef.current.destroy()
        chartsRef.current = new G2.Chart({
            container: 'member-data-chart-container',
            height: 320,
            autoFit: true,
        })

        const chartData = props.dataList
            .slice()
            .sort((a, b) => a.date.localeCompare(b.date))
            .flatMap(row => [
                { date: formatDate(row.date, props.scope), name: '充值金额', amount: Number(row.recharge_amount) || 0 },
                { date: formatDate(row.date, props.scope), name: '余额消费', amount: Number(row.consume_amount) || 0 },
                {
                    date: formatDate(row.date, props.scope),
                    name: '新增会员',
                    amount: Number(row.member_registered) || 0,
                },
            ])

        chartsRef.current.data(chartData)
        chartsRef.current.scale('amount', { tickCount: 5 })
        chartsRef.current.scale('date', { tickCount: 7 })
        chartsRef.current.axis('date', {
            label: {
                style: { fill: '#999' },
            },
        })
        chartsRef.current.tooltip({ showCrosshairs: true, shared: true })
        chartsRef.current.legend({
            marker: { symbol: 'circle' },
            itemName: {
                style: { fill: '#999', fontSize: 14 },
            },
        })

        const colors = ['#5dc99e', '#5ea1f3', '#e88f5e']

        chartsRef.current.area().position('date*amount').color('name', colors).style({ fillOpacity: 0.1 })
        chartsRef.current.line().position('date*amount').color('name', colors).style({ lineWidth: 2 })

        chartsRef.current.render()
    }, [props.dataList, props.scope])

    useEffect(() => {
        return () => {
            if (chartsRef.current) chartsRef.current.destroy()
        }
    }, [])

    return <div id="member-data-chart-container" style={{ width: '100%', height: '320px' }} />
}

export default MemberDataChart
